import { useLocation, useNavigate } from 'react-router-dom';
import styles from './header.module.scss';
import { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import menuData from 'data/menu';
import { BiSolidUser } from 'react-icons/bi';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RiSettings5Fill } from 'react-icons/ri';
import { MdLogout } from 'react-icons/md';
import UserEdit from './edit';
import { clearUser } from 'redux/slices/auth';
import { clearCurrent } from 'redux/slices/currentPage';
import { clearTankList } from 'redux/slices/tank';

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(false);
  const [edit, setEdit] = useState(false);
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const navigate = useNavigate();
  const selectRef = useRef(null);
  const dispatch = useDispatch();

  const handleClose = () => setAnchorEl(!anchorEl);

  const handleClick = (e) => {
    setAnchorEl(false);
    navigate(e);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (e) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setAnchorEl(false);
    }
  };

  const handleLogout = () => {
    dispatch(clearUser());
    dispatch(clearCurrent());
    dispatch(clearTankList());
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <header className={styles.header} ref={selectRef}>
      <div className={styles.panels}>
        {menuData()?.filter((item) => !item?.hidden).map((item, id) => (
          <Box
            key={item.id + '-' + id}
            onClick={() => {
              !item?.menu && handleClick(item?.url);
              item?.menu && handleClose();
            }}
            className={`${
              Object.values(item.permission).includes('read')
                ? styles.navItem
                : styles.disableItem
            } 
              ${pathname === `/${item?.url}` && styles.activeNavItem} 
              ${item?.menu && styles.menuPanel}`}
          >
            {item.name}
          </Box>
        ))}
      </div>

      <Box
        ref={selectRef}
        className={
          anchorEl ? `${styles.menu} ${styles.menuActive}` : styles.menu
        }
      >
        <Box className={styles.menuItem}>
          <BiSolidUser /> {user?.name}
        </Box>
        <Box
          onClick={() => {
            setAnchorEl(false);
            setEdit(true);
          }}
          className={styles.menuItem}
        >
          <RiSettings5Fill /> Настройки
        </Box>
        <Box onClick={handleLogout} className={styles.menuItem}>
          <MdLogout /> Выйти из системы
        </Box>
      </Box>

      {edit && <UserEdit open={edit} handleCancel={() => setEdit(false)} />}
    </header>
  );
};

export default Header;
